// context/TipoEspacioContext.js
import React, { createContext, useState, useContext } from 'react';

const TipoEspacioContext = createContext();

export const useTipoEspacio = () => {
  return useContext(TipoEspacioContext);
};

export const TipoEspacioProvider = ({ children }) => {
  const [tipoSeleccionado, setTipoSeleccionado] = useState(null); // Estado global para el tipo seleccionado

  return (
    <TipoEspacioContext.Provider value={{ tipoSeleccionado, setTipoSeleccionado }}>
      {children}
    </TipoEspacioContext.Provider>
  );
};
